/**
 * Get sort by icon.
 * @param {string} sortBy
 * @returns {string} Sort By Icon String
 */
export const getSortByIcon = sortBy => {
  switch (sortBy) {
    case 'customer':
      return 'user'

    case 'dateCreated':
      return 'calendar'

    case 'dateOrder':
      return 'calendar'

    case 'dateReceipt':
      return 'add to calendar'

    case 'dateScanned':
      return 'calendar check'

    case 'dessin':
      return 'block layout'

    case 'id':
      return 'hashtag'

    case 'name':
      return 'tag'

    case 'pictureCount':
      return 'file image outline'

    case 'pictureSource':
      return 'camera'

    case 'producer':
      return 'factory'

    case 'quality':
      return 'share alternate'

    case 'rugs':
      return 'search'

    case 'sizeQm':
      return 'expand'

    case 'status':
      return 'shopping basket'

    default:
      return ''
  }
}
